






import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';

@Component({})
export default class AppDialog extends Vue {
  @Prop(Boolean) open!: boolean;
  @Emit()
  close() {
    return;
  }

  get _open() {
    return this.open;
  }

  set _open(_: boolean) {
    // When _open changes, it means that the user has clicked outside the dialog, and thereby closed is.
    this.close();
  }
}
